import { api } from './base-api';
import {
  Aviso,
  AvisoDetail,
  AvisosFilters,
  CreateAvisoPayload,
  PaginatedAvisos,
  UpdateAvisoPayload,
} from '../../types/aviso';

const cleanParams = (filters: Record<string, unknown>) => {
  const result: Record<string, string | number | boolean> = {};
  for (const [key, value] of Object.entries(filters)) {
    if (value === undefined || value === null || value === '') continue;
    result[key] = value as string | number | boolean;
  }
  return result;
};

export interface ListAvisosParams extends Partial<AvisosFilters> {
  page?: number;
  limit?: number;
}

export const avisosApi = {
  async list(params: ListAvisosParams = {}): Promise<PaginatedAvisos> {
    const { data } = await api.get<PaginatedAvisos>('/admin/avisos', {
      params: cleanParams({ ...(params as Record<string, unknown>) }),
    });
    return data;
  },

  async detail(id: string): Promise<AvisoDetail> {
    const { data } = await api.get<AvisoDetail>(`/admin/avisos/${id}`);
    return data;
  },

  async create(payload: CreateAvisoPayload): Promise<AvisoDetail> {
    const { data } = await api.post<AvisoDetail>('/admin/avisos', payload);
    return data;
  },

  async update(id: string, payload: UpdateAvisoPayload): Promise<AvisoDetail> {
    const { data } = await api.patch<AvisoDetail>(
      `/admin/avisos/${id}`,
      payload,
    );
    return data;
  },

  async activate(id: string): Promise<AvisoDetail> {
    const { data } = await api.patch<AvisoDetail>(
      `/admin/avisos/${id}/ativar`,
    );
    return data;
  },

  async deactivate(id: string): Promise<AvisoDetail> {
    const { data } = await api.patch<AvisoDetail>(
      `/admin/avisos/${id}/desativar`,
    );
    return data;
  },
};

export type { Aviso };
